module.exports = __webpack_public_path__ + "static/img/23.393b65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/23.png
// module id = nVl6
// module chunks = 1